import { TranslateService } from '@ngx-translate/core';

import { InsightsSummaryDataKpi } from '../../coaching-insight/insight-widget/model/insights-summary-data-kpi.model';
import { KpiType } from '../../coaching-insight/insight-widget/model/kpi-type.model';
import { AxisDataAxisPath } from '../../scorecard-mi2/chart/axis-data-axis-path';
import { TrendDialogMode } from '../../scorecard-mi2/trend-dialog/model/trend-dialog-mode.model';
import { epicDependencies } from '../../store';
import { rect } from '../constants/trend-chart-rect-config';
import { CoachingTrendData } from '../models/coaching-trend-data.model';
import { Mi2ScoreData } from '../models/mi2-score-data';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

import { createTargetPoints } from './create-target-points.function';
import { getLegends } from './get-legends.function';
import { getScorecardChart } from './get-scorecard-chart.function';

export function getMi2TrendDataSet(
    mi2ScoreData: Mi2ScoreData[],
    kpiType: InsightsSummaryDataKpi,
): CoachingTrendData {
    const isFlMi2 =
        kpiType.kpiTypeId === KpiType.FL_MANAGEMENT_IMPROVEMENT_INDEX;
    const yAxisText = isFlMi2
        ? TranslationKeyMap._11119_FLMI2_SCORE
        : TranslationKeyMap._9878_MI2_SCORE;
    const trendTitleText = isFlMi2
        ? TranslationKeyMap._11120_FLMI2_TREND
        : TranslationKeyMap._10074_MI2_TREND;

    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);
    const { leftTicks, rightTicks, points } = getScorecardChart(
        mi2ScoreData,
        kpiType.kpiInitials,
    );
    const trendData = mi2ScoreData.map((data) => ({
        periodDate: data.periodDate,
        target: data.target != null ? data.target / 100 : null,
    }));
    const targetPoints = createTargetPoints(trendData, '#000');
    const targetKey = translateService.instant(TranslationKeyMap._726_TARGET);
    const paths: AxisDataAxisPath[] = [
        {
            key: targetKey,
            points: targetPoints,
        },
        {
            key: kpiType.kpiInitials,
            points,
        },
    ];
    const legends = getLegends(paths);
    const mi2TrendData: CoachingTrendData = {
        mode: TrendDialogMode.MI2,
        showYAxisLabel2: false,
        leftTicks,
        rightTicks,
        paths,
        legends,
        rect,
        trendTitle: translateService.instant(trendTitleText),
        yAxisTitle: translateService.instant(yAxisText),
    };
    return mi2TrendData;
}
